import common from './Common';
import sales from './Sales';
import customer from './Customer';
import perm from './Perm';

export default {
  common,
  sales,
  customer,
  perm,
};
